import { InferType, array, boolean, date, mixed, object, string } from "yup";

export const traceabilityBrokenReasonSchema = mixed<
  | "MISSING_UPSTREAM"
  | "MISSING_DOWNSTREAM"
  | "MISSING_SOURCE_LINK"
  | "NO_FILE_REFERENCE"
>()
  .oneOf([
    "MISSING_UPSTREAM",
    "MISSING_DOWNSTREAM",
    "MISSING_SOURCE_LINK",
    "NO_FILE_REFERENCE",
  ])
  .required();

export const traceabilityNodeKindSchema = mixed<
  | "UN"
  | "SR"
  | "SSR"
  | "DESIGN_SPEC"
  | "ST"
  | "VT"
  | "VALIDATION_FILE"
  | "RK"
  | "RC"
>()
  .oneOf([
    "UN",
    "SR",
    "SSR",
    "DESIGN_SPEC",
    "ST",
    "VT",
    "VALIDATION_FILE",
    "RK",
    "RC",
  ])
  .required();

export const traceabilityRelationTypeSchema = mixed<
  | "UN_TO_SR"
  | "SR_TO_SSR"
  | "RK_TO_RC"
  | "RC_TO_SSR"
  | "SSR_TO_DESIGN_SPEC"
  | "DESIGN_SPEC_TO_TEST"
  | "TEST_TO_VALIDATION_FILE"
>()
  .oneOf([
    "UN_TO_SR",
    "SR_TO_SSR",
    "RK_TO_RC",
    "RC_TO_SSR",
    "SSR_TO_DESIGN_SPEC",
    "DESIGN_SPEC_TO_TEST",
    "TEST_TO_VALIDATION_FILE",
  ])
  .required();

export const traceabilityChainSchema = object({
  id: string().required(),
  title: string().required(),
  rootLabel: string().required(),
  isBroken: boolean().required(),
  hasMissingUpstream: boolean().required(),
  ssrIds: array(string().required()).required(),
  testIds: array(string().required()).required(),
  mermaidDefinition: string().required(),
});

export const traceabilityRelationEndpointSchema = object({
  traceabilityId: string().nullable().defined(),
  kind: traceabilityNodeKindSchema.required(),
  label: string().required(),
});

export const traceabilityRelationSchema = object({
  id: string().required(),
  relation: traceabilityRelationTypeSchema.required(),
  isBroken: boolean().required(),
  brokenReasons: array(traceabilityBrokenReasonSchema).required(),
  source: traceabilityRelationEndpointSchema.required(),
  target: traceabilityRelationEndpointSchema.required(),
});

export const traceabilityMatrixSchema = object({
  deviceId: string().uuid().required(),
  organizationId: string().uuid().required(),
  generatedAt: date().required(),
  chains: array(traceabilityChainSchema).required(),
  relations: array(traceabilityRelationSchema).required(),
});

export interface TraceabilityChain
  extends InferType<typeof traceabilityChainSchema> {}

export interface TraceabilityRelation
  extends InferType<typeof traceabilityRelationSchema> {}

export interface TraceabilityMatrix
  extends InferType<typeof traceabilityMatrixSchema> {}
